import React from "react";
import { useNavigate } from "react-router-dom";

const CaseStudiesSection = () => {
  const navigate = useNavigate();

  const cards = [
    {
      id: "finance",
      title: "Finance & Banking",
      desc: "Secure high-value transactions and banking portals with zero-trust biometric auth.",
      gradient: "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
      path: "/finance",
      icon: "🏦",
      image: "https://images.unsplash.com/photo-1501167786227-4cba60f6d58f?w=600&q=80"
    },
    {
      id: "healthcare",
      title: "Healthcare",
      desc: "Protect sensitive patient records and maintain HIPAA compliance effortlessly.",
      gradient: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
      path: "/healthcare",
      icon: "🏥",
      image: "https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=600&q=80"
    },
    {
      id: "insurance",
      title: "Insurance",
      desc: "Streamline claims and member portals with instant verified access.",
      gradient: "linear-gradient(135deg, #f12711 0%, #f5af19 100%)",
      path: "/insurance",
      icon: "🛡️",
      image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&q=80"
    },
    {
      id: "government",
      title: "Government",
      desc: "Deliver secure citizen services and internal portals with military-grade security.",
      gradient: "linear-gradient(135deg, #141E30 0%, #243B55 100%)",
      path: "/government",
      icon: "🏛️",
      image: "https://images.unsplash.com/photo-1555848962-6e79363ec58f?w=600&q=80"
    },
    {
      id: "corporate",
      title: "Corporate Identity",
      desc: "Unified single sign-on for enterprise networks, preventing employee phishing.",
      gradient: "linear-gradient(135deg, #8E2DE2 0%, #4A00E0 100%)",
      path: "/corporate",
      icon: "🏢",
      image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&q=80"
    }
  ];

  return (
    <div id="case-studies" style={{ padding: "80px 250px", backgroundColor: "#f8fafc" }}>
      <style>
        {`
          .industry-card {
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            cursor: pointer;
            overflow: hidden;
            position: relative;
          }
          .industry-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 25px 50px rgba(0, 0, 0, 0.18) !important;
          }
          .industry-card:hover .industry-img {
            transform: scale(1.08);
          }
          .industry-img {
            transition: transform 0.5s ease;
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
          }
          .industry-card:hover .card-arrow {
            opacity: 1;
            transform: translateX(4px);
          }
          .card-arrow {
            opacity: 0;
            transition: all 0.3s ease;
          }
        `}
      </style>
      <h2 style={{ fontSize: "2rem", fontWeight: "800", marginBottom: "12px", color: "#1a1a1a", letterSpacing: "-0.5px", marginLeft: "15px" }}>
        Industry Solutions
      </h2>
      <p style={{ color: "#666", fontSize: "1rem", marginBottom: "40px", marginLeft: "15px" }}>
        See how Legitimately U seamlessly integrates across every major sector.
      </p>
      
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "28px", padding: "0 15px" }}>
        {cards.map(card => (
          <div 
            key={card.id} 
            className="industry-card"
            style={{
              borderRadius: "20px",
              backgroundColor: "#fff",
              boxShadow: "0 15px 35px rgba(0,0,0,0.12)",
              border: "1px solid rgba(0,0,0,0.12)",
              display: "flex",
              flexDirection: "column"
            }}
            onClick={() => window.open(card.path, "_blank")}
          >
            <div style={{ height: "190px", borderTopLeftRadius: "20px", borderTopRightRadius: "20px", overflow: "hidden", position: "relative" }}>
              <img
                src={card.image}
                alt={card.title}
                className="industry-img"
              />
              <div style={{
                position: "absolute", inset: 0,
                background: card.gradient,
                opacity: 0.55,
                borderTopLeftRadius: "20px",
                borderTopRightRadius: "20px"
              }} />
              <div style={{
                position: "absolute", bottom: "16px", left: "20px",
                fontSize: "2.2rem",
                filter: "drop-shadow(0 2px 6px rgba(0,0,0,0.4))"
              }}>
                {card.icon}
              </div>
            </div>
            <div style={{ padding: "22px 25px 25px" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <h3 style={{ fontSize: "1.2rem", fontWeight: "700", marginBottom: "10px", color: "#111", margin: 0 }}>
                  {card.title}
                </h3>
                <span className="card-arrow" style={{ fontSize: "1.2rem", color: "#ff0000" }}>→</span>
              </div>
              <p style={{ color: "#666", fontSize: "0.92rem", lineHeight: "1.6", marginTop: "10px" }}>
                {card.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CaseStudiesSection;
